import { Module } from '@/modules/core/app/constants/app.constants';
import { ClusterRoute, ClusterPathName } from '@/modules/ta/cluster/cluster.constants';
import { ClusterRouteConfig } from '@/modules/ta/cluster/ClusterRouteConfig';

export const router = ClusterRouteConfig.factory(
  [
    {
      path: `/${ClusterRoute.CLUSTERS}`,
      name: ClusterPathName.CLUSTERS,
      component: () => import(/* webpackChunkName: "clusters-page" */ './pages/ClustersPage.vue'),
    },
    {
      path: `/${ClusterRoute.CLUSTERS}/new`,
      name: ClusterPathName.CLUSTERFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "cluster-form-page" */ './pages/ClusterFormPage.vue'),
      props: true,
    },
    {
      path: `/${ClusterRoute.CLUSTERS}/:id`,
      name: ClusterPathName.CLUSTERFORM,
      component: () =>
        import(/* webpackChunkName: "cluster-form-page" */ './pages/ClusterFormPage.vue'),
      props: true,
    },
  ],
  Module.CLUSTER
);
